export default __webpack_public_path__ + "static/media/web.750d5e35.png";